<template>
    <div>
      <div class="row" >
        <button @click="openConfig" v-show="!contentConfig">{{!contentConfig? 'Exibir Configurações': ''}}</button>
        <div class="row glocal-config-content" v-show="contentConfig">
          <!-- Name of quiz -->
      
    
          <div class="col-form-inner col-3 col-md-3 col-lg-3">
            <div class="form-group">
              <label class="label-form">
              Quantidade de Questões
              </label>
              <select v-model="qtdQuestions" class="select-mode" >
                <option value="0" disabled selected>0</option>
                <option :value="index" v-for="index in 10" :key="index">{{ index }}</option>
              </select>
            </div>
          </div>
          <div class="col-form-inner col-3 col-md-3 col-lg-3">
            <div class="form-group">
              <label class="label-form">
              Quantidade de Respostas
              </label>
              <select v-model="qtyAnswer" class="select-mode">
                <option value="0" disabled selected>0</option>
                <option :value="index" v-for="index in 5" :key="index">{{ index }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="answer" v-for="i in qtdQuestions" :key="index" >
          <div class="input-title-quiz">
            <div class="form-group">
              <label class="label-form">
              Questão {{i}}
              </label>
            </div>
            <div class="quileditor">
  
              <QuillEditor
              v-model:content="contentQuestions[i-1]"
                @input="updateContent(i-1, $event.srcElement.innerHTML)"
                theme="snow"
                toolbar="essential"
                contentType="html"
                />
            </div>
          </div>
          <div class="global-content-answer">
            <div class="tabs-answer" >
              <div class="tab" :class="[active[i][j] == true ? 'active-tab':'']" v-for="j in qtyAnswer" :key="j">
                <label class="label-form" @click="changeValueTab(i,j)" >
                Alternativa {{alternatives[j-1]}}
                </label>
              </div>
            </div>
            <div class="input-group" v-for="k in qtyAnswer" :key="k" v-show="active[i][k] == true">
              <div class="input-group-text">
                <input class="form-check-input mt-0" :value="i+'-'+alternatives[k-1]"  v-model="selectedOption[i-1]" type="radio"  aria-label="Radio button for following text input">
              </div>
              <div class="inputAnswer">
                <QuillEditor
                  :value="contentAnswers[i,k]"
                  @input="updateContentAnswer(i-1, k-1, $event.srcElement.innerHTML)"
                  theme="snow"
                  toolbar="essential"
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click="createObject()" class="btn-add-module">Criar Quiz</button>
    
    
    <div class="quileditor">
      <QuillEditor
        v-model:content="teste"
        @input="updateContent(i-1, $event.srcElement.innerHTML)"
        theme="snow"
        toolbar="essential"
        contentType="html"
        />
    </div>
    {{ contentQuestions[0] }}
    {{ contentQuestions[1] }}
    {{ contentQuestions[2] }}
    
  
  </template>
  <script>
  import { ref } from 'vue';
  
    export default {
      data() {
        const numRows = 100; 
        const numCols = 100; 
    
        const initialMatrix = Array.from({ length: numRows }, () =>
          Array.from({ length: numCols }, () => false)
        );
    
        return {
          contentQuestions:[],
          contentAnswers: [[],[]],
          qtdQuestions: 0,
          qtyAnswer: 0,
          quillEditors: [],
          active: initialMatrix,
          hidetab:[],
          selectedOption:[],
          typefile2:"Ativo",
          alternatives:['A','B','C','D','E'],
          showQuestion:[],
          contentConfig:true,
          namequiz: 'Quiz - Exercícios de Fixação',
          passingscore: 7,
          maxscore: 10,
          status: 'ativo',
          qtdQuestions: 1,
          qtyAnswer: 5,
          teste:'<h1>This is html header 3</h1>',
  
        };
      },
      created(){
          this.contentQuestions = [

            '<h1>This is html header 1</h1>',
            '<h1>This is html header 2</h1>',
            '<h1>This is html header 3</h1>',
            ];
      },
      methods: {
        updateContent(i, content) {
          this.contentQuestions[i] = content;
        },
        updateContentAnswer(i, j, content) {
          if (!this.contentAnswers[i]) {
            this.contentAnswers[i] = [];
          }
          this.contentAnswers[i][j] = content;
        },
        changeValueTab(value1, value2) {
            for (let i = 1; i <= this.qtyAnswer; i++) {
              this.active[value1][i] = false;
            }
            this.active[value1][value2] = true;
          },
          isActive(i, j) {
            return this.active[i][j] === true;
          },
          hidetab(value){
            this.hidetab[value]=false;
          },
          closetab(index){
            this.showQuestion[index]=!this.showQuestion[index];
          },
          openConfig(){
            this.contentConfig=true;
          },
          createObject() {
            const objetos = [];
  
            for (let index = 0; index < this.qtdQuestions; index++) {
              let question = this.contentQuestions[index];
              let answerOption = this.selectedOption[index];
  
              let objAnswer = []; 
  
              for (let j = 0; j < this.qtyAnswer; j++) {
                objAnswer.push(this.contentAnswers[index][j]); 
  
              }
  
              let objeto = {
                'Nome da questão': question,
                'Resposta da questão': answerOption,
                'Opções das Respostas': objAnswer
              };
  
              objetos.push(objeto);
            }
          },
  
        },
      mounted() {
        for (let index = 1; index <= 10; index++) {
          this.active[index][1] = true;
        }
        this.hidetab[1]=true
      },
    };
  </script>
  <style>
@import './quiz.css';
</style>